// Frontend API Routes
export const API_URL = '/api'
